import {Dimensions} from './dimensions'

export const DEFAULT_DIMENSIONS_DATA: Dimensions = {
    height: -1,
    width: -1,
}
